var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gyroAccess is-flex is-flex-direction-column"},[_vm._t("default",null,{"DeviceOrientationEnabled":_vm.DeviceOrientationEnabled,"dataStarted":_vm.dataStarted,"callibrated":_vm.callibrated,"alpha":_vm.alpha,"beta":_vm.beta,"gamma":_vm.gamma,"x":_vm.coords.x,"y":_vm.coords.y,"z":_vm.coords.z,"noGyro":_vm.noGyro})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }